import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import arCommon from './locales/ar/common.json';
import arAuth from './locales/ar/auth.json';
import arDashboard from './locales/ar/dashboard.json';
import arErrors from './locales/ar/errors.json';
import arNavigation from './locales/ar/navigation.json';
import arNotifications from './locales/ar/notifications.json';
import arPricing from './locales/ar/pricing.json';
import arSettings from './locales/ar/settings.json';
import arSubscription from './locales/ar/subscription.json';
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enErrors from './locales/en/errors.json';
import enNavigation from './locales/en/navigation.json';
import enNotifications from './locales/en/notifications.json';
import enPricing from './locales/en/pricing.json';
import enSettings from './locales/en/settings.json';
import enSubscription from './locales/en/subscription.json';

export const supportedLanguages = ['ar', 'en'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const LANGUAGE_STORAGE_KEY = 'class-tech-language';

const storedLanguage =
  typeof window !== 'undefined'
    ? window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
    : null;

export const getInitialLanguage = (): SupportedLanguage =>
  storedLanguage === 'en' || storedLanguage === 'ar' ? storedLanguage : 'ar';

i18n.use(initReactI18next).init({
  resources: {
    ar: {
      common: arCommon,
      auth: arAuth,
      dashboard: arDashboard,
      errors: arErrors,
      navigation: arNavigation,
      notifications: arNotifications,
      pricing: arPricing,
      settings: arSettings,
      subscription: arSubscription,
    },
    en: {
      common: enCommon,
      auth: enAuth,
      dashboard: enDashboard,
      errors: enErrors,
      navigation: enNavigation,
      notifications: enNotifications,
      pricing: enPricing,
      settings: enSettings,
      subscription: enSubscription,
    },
  },
  lng: getInitialLanguage(),
  fallbackLng: 'ar',
  ns: [
    'common',
    'navigation',
    'settings',
    'auth',
    'dashboard',
    'errors',
    'notifications',
    'pricing',
    'subscription',
  ],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
